export enum AreaVariableType {
  AREA = 'AreaVariableDoubleDTO',
  AREA_STRING = 'AreaVariableStringDTO',
  AREA_DATE = 'AreaVariableDateDTO',
  CUSTOM = 'CustomVariableDoubleDTO',
  CUSTOM_VARIABLE = 'CustomDoubleVariable'
}
